import { useState, useEffect, useCallback } from 'react';
import { getRecoil } from 'recoil-nexus';
import { atom, useRecoilState, useSetRecoilState } from 'recoil';

import { EventEmitter } from '../utils/eventEmitter';
import { isInDebankApp } from '../utils/common';
import { isIos } from '../consts/platform';

export enum DEVICE_TYPE {
  PC,
  TABLET,
  MOBILE,
}

let DriverWidth = 0;

const excludeMobile = ['/invest'];

let type = getDriverType();
export let deviceTypeIsMobile = type === DEVICE_TYPE.MOBILE;

export function getDriverType() {
  const inApp = isInDebankApp();
  if (inApp && isIos) {
    // IOS / IPAD 且在 app 中打开时，强制设为 mobile
    return DEVICE_TYPE.MOBILE;
  }
  const { innerWidth, outerWidth } = window;
  let width = innerWidth;
  if (outerWidth && outerWidth < innerWidth && outerWidth >= 320) {
    width = outerWidth;
  }
  DriverWidth = width;
  if (width > 1240) {
    return DEVICE_TYPE.PC;
  } else if (width < 600 && !excludeMobile.find(v => window.location.pathname.startsWith(v))) {
    return DEVICE_TYPE.MOBILE;
  } else {
    return DEVICE_TYPE.TABLET;
  }
}

export { DriverWidth };

const eventEntry = new EventEmitter();

export const checkDeviceInfo = () => {
  const _type = type;
  type = getDriverType();
  if (type === _type) return;
  deviceTypeIsMobile = type === DEVICE_TYPE.MOBILE;
  eventEntry.emit('changeDeviceType');
  eventEntry.emit('changeIsMobile');
};

window.addEventListener('resize', checkDeviceInfo);

export function useDeviceType(): DEVICE_TYPE {
  const [t, setT] = useState(type);
  useEffect(function () {
    function boundReset() {
      setT(type);
    }
    eventEntry.on('changeDeviceType', boundReset);
    return function () {
      eventEntry.off('changeDeviceType', boundReset);
    };
  }, []);
  return t;
}

export const isMobileState = atom({
  key: 'isMobileState',
  default: deviceTypeIsMobile,
});

export function useDeviceTypeIsMobile(): boolean {
  const [t, setT] = useRecoilState(isMobileState);
  useEffect(
    function () {
      function boundReset() {
        setT(deviceTypeIsMobile);
      }
      eventEntry.on('changeIsMobile', boundReset);

      return function () {
        eventEntry.off('changeIsMobile', boundReset);
      };
    },
    [setT],
  );
  return t;
}

export const useForceSetPc = () => {
  const setIsMobileState = useSetRecoilState(isMobileState);
  return useCallback(() => {
    setIsMobileState(false);
    deviceTypeIsMobile = false;
  }, [setIsMobileState]);
};

export const getIsMobile = () => {
  return getRecoil(isMobileState);
};

export default useDeviceType;
